var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hello" }, [
    _c("div", { staticClass: "row" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "col-auto" }, [
        _c(
          "form",
          {
            staticClass: "form-inline",
            on: {
              submit: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.period,
                    expression: "period"
                  }
                ],
                staticClass: "form-control",
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.period = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { attrs: { value: "current" } }, [
                  _vm._v("Current Month")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "last" } }, [
                  _vm._v("Previous Month")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "custom" } }, [
                  _vm._v("Custom Date Range")
                ])
              ]
            ),
            _vm._v(" "),
            _vm.period === "custom"
              ? _c("date-picker", {
                  attrs: { config: _vm.options },
                  model: {
                    value: _vm.fromDate,
                    callback: function($$v) {
                      _vm.fromDate = $$v
                    },
                    expression: "fromDate"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.period === "custom"
              ? _c("date-picker", {
                  attrs: { config: _vm.options },
                  model: {
                    value: _vm.toDate,
                    callback: function($$v) {
                      _vm.toDate = $$v
                    },
                    expression: "toDate"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-dropdown",
              {
                ref: "dropdown",
                staticClass: "m-2",
                attrs: {
                  size: "sm",
                  variant: "outline-secondary",
                  id: "dropdown-form",
                  text: _vm.saleTypeText
                }
              },
              [
                _c(
                  "b-dropdown-form",
                  [
                    _c("b-form-checkbox-group", {
                      attrs: {
                        id: "checkbox-group-1",
                        options: _vm.saleTypes,
                        name: "flavour-1"
                      },
                      model: {
                        value: _vm.saleType,
                        callback: function($$v) {
                          _vm.saleType = $$v
                        },
                        expression: "saleType"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.isAdmin || _vm.isUser
              ? _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.group,
                        expression: "group"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.group = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        function($event) {
                          return _vm.groupChanged()
                        }
                      ]
                    }
                  },
                  [
                    _c("option", { domProps: { value: 0 } }, [
                      _vm._v("All Groups")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.groups, function(l) {
                      return _c("option", { key: l, domProps: { value: l } }, [
                        _vm._v(_vm._s(l))
                      ])
                    })
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isAdmin || _vm.isUser
              ? _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.division,
                        expression: "division"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { disabled: _vm.group === 0 },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.division = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { domProps: { value: 0 } }, [
                      _vm._v("All Divisions")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.divisions, function(l) {
                      return _c("option", { key: l, domProps: { value: l } }, [
                        _vm._v(_vm._s(l))
                      ])
                    })
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isAdmin || _vm.isUser
              ? _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.location,
                        expression: "location"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.location = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { domProps: { value: 0 } }, [
                      _vm._v("All Locations")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.locations, function(l) {
                      return _c(
                        "option",
                        { key: l.id, domProps: { value: l.id } },
                        [
                          _vm._v(
                            _vm._s(l.name) + " – " + _vm._s(l.codes.join(","))
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isAdmin || _vm.isUser
              ? _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.transporter,
                        expression: "transporter"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.transporter = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { domProps: { value: 0 } }, [
                      _vm._v("All Transporters")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.transporters, function(l) {
                      return _c(
                        "option",
                        { key: l.id, domProps: { value: l.id } },
                        [_vm._v(_vm._s(l.name))]
                      )
                    })
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isAdmin
              ? _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.aggregate,
                        expression: "aggregate"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.aggregate = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "COUNT" } }, [
                      _vm._v("Invoice Counts")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "SUM" } }, [
                      _vm._v("Invoice Values (in Lacs)")
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-sm mt-1",
                on: { click: _vm.loadDashboard }
              },
              [
                !_vm.updating
                  ? _c("span", [
                      _c("i", { staticClass: "fa fa-sync" }),
                      _vm._v(" Update")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.updating
                  ? _c("span", [
                      _c("i", { staticClass: "fa fa-sync fa-spin" }),
                      _vm._v(" Updating")
                    ])
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-3 mb-3" }, [
      _c("div", { staticClass: "col-12 pod-home-page" }, [
        _c("div", { staticClass: "card-deck" }, [
          _c(
            "div",
            { staticClass: "card text-white", style: _vm.makeBGColor(0) },
            [
              _c("div", { staticClass: "card-header" }, [
                _c(
                  "a",
                  {
                    staticClass: "text-white",
                    attrs: { href: _vm.getUrl("created") }
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "div",
                          { staticClass: "row justify-content-between" },
                          [
                            _vm._m(1),
                            _vm._v(" "),
                            _c("div", { staticClass: "col text-right small" }, [
                              _vm._v(_vm._s(_vm.pods.created))
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 text-right mt-2 text-uppercase small"
                        },
                        [
                          _vm._v(
                            "\n                  Created\n                "
                          )
                        ]
                      )
                    ])
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card text-white", style: _vm.makeBGColor(6) },
            [
              _c("div", { staticClass: "card-header" }, [
                _c(
                  "a",
                  {
                    staticClass: "text-white",
                    attrs: { href: _vm.getUrl("cancelled") }
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "div",
                          { staticClass: "row justify-content-between" },
                          [
                            _vm._m(2),
                            _vm._v(" "),
                            _c("div", { staticClass: "col text-right small" }, [
                              _vm._v(_vm._s(_vm.pods.cancelled))
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 text-right mt-2 text-uppercase small"
                        },
                        [
                          _vm._v(
                            "\n                  Cancelled\n                "
                          )
                        ]
                      )
                    ])
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card text-white", style: _vm.makeBGColor(9) },
            [
              _c("div", { staticClass: "card-header" }, [
                _c(
                  "a",
                  {
                    staticClass: "text-white",
                    attrs: { href: _vm.getUrl("services") }
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "div",
                          { staticClass: "row justify-content-between" },
                          [
                            _vm._m(3),
                            _vm._v(" "),
                            _c("div", { staticClass: "col text-right small" }, [
                              _vm._v(_vm._s(_vm.pods.noshipping))
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 text-right mt-2 text-uppercase small"
                        },
                        [
                          _vm._v(
                            "\n                  Service Invoice (NPD)\n                "
                          )
                        ]
                      )
                    ])
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "card text-white text-white",
              style: _vm.makeBGColor(1)
            },
            [
              _c("div", { staticClass: "card-header" }, [
                _c(
                  "a",
                  {
                    staticClass: "text-white",
                    attrs: { href: _vm.getUrl("shipped") }
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "div",
                          { staticClass: "row justify-content-between" },
                          [
                            _vm._m(4),
                            _vm._v(" "),
                            _c("div", { staticClass: "col text-right small" }, [
                              _vm._v(_vm._s(_vm.pods.shipped))
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 text-right mt-2 text-uppercase small"
                        },
                        [
                          _vm._v(
                            "\n                  Shipped\n                "
                          )
                        ]
                      )
                    ])
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card text-white", style: _vm.makeBGColor(2) },
            [
              _c("div", { staticClass: "card-header" }, [
                _c(
                  "a",
                  {
                    staticClass: "text-white",
                    attrs: { href: _vm.getUrl("delivered") }
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "div",
                          { staticClass: "row justify-content-between" },
                          [
                            _vm._m(5),
                            _vm._v(" "),
                            _c("div", { staticClass: "col text-right small" }, [
                              _vm._v(_vm._s(_vm.pods.delivered))
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 text-right mt-2 text-uppercase small"
                        },
                        [
                          _vm._v(
                            "\n                  Delivered\n                "
                          )
                        ]
                      )
                    ])
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card text-white", style: _vm.makeBGColor(7) },
            [
              _c("div", { staticClass: "card-header" }, [
                _c(
                  "a",
                  {
                    staticClass: "text-white",
                    attrs: { href: _vm.getUrl("returned") }
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "div",
                          { staticClass: "row justify-content-between" },
                          [
                            _vm._m(6),
                            _vm._v(" "),
                            _c("div", { staticClass: "col text-right small" }, [
                              _vm._v(_vm._s(_vm.pods.returned))
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 text-right mt-2 text-uppercase small"
                        },
                        [
                          _vm._v(
                            "\n                  Returned\n                "
                          )
                        ]
                      )
                    ])
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card text-white", style: _vm.makeBGColor(3) },
            [
              _c("div", { staticClass: "card-header" }, [
                _c(
                  "a",
                  {
                    staticClass: "text-white",
                    attrs: { href: _vm.getUrl("uploaded") }
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "div",
                          { staticClass: "row justify-content-between" },
                          [
                            _vm._m(7),
                            _vm._v(" "),
                            _c("div", { staticClass: "col text-right small" }, [
                              _vm._v(_vm._s(_vm.pods.uploaded))
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 text-right mt-2 text-uppercase small"
                        },
                        [
                          _vm._v(
                            "\n                  POD Uploaded\n                "
                          )
                        ]
                      )
                    ])
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card text-white", style: _vm.makeBGColor(5) },
            [
              _c("div", { staticClass: "card-header" }, [
                _c(
                  "a",
                  {
                    staticClass: "text-white",
                    attrs: { href: _vm.getUrl("undelivered") }
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "div",
                          { staticClass: "row justify-content-between" },
                          [
                            _vm._m(8),
                            _vm._v(" "),
                            _c("div", { staticClass: "col text-right small" }, [
                              _vm._v(_vm._s(_vm.pods.undelivered))
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 text-right mt-2 text-uppercase small"
                        },
                        [
                          _vm._v(
                            "\n                  In-Transit\n                "
                          )
                        ]
                      )
                    ])
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card text-white", style: _vm.makeBGColor(4) },
            [
              _c("div", { staticClass: "card-header" }, [
                _c(
                  "a",
                  {
                    staticClass: "text-white",
                    attrs: { href: _vm.getUrl("pending") }
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "div",
                          { staticClass: "row justify-content-between" },
                          [
                            _vm._m(9),
                            _vm._v(" "),
                            _c("div", { staticClass: "col text-right small" }, [
                              _vm._v(_vm._s(_vm.pods.pending))
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 text-right mt-2 text-uppercase small"
                        },
                        [
                          _vm._v(
                            "\n                  POD Pending\n                "
                          )
                        ]
                      )
                    ])
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "card text-white d-none",
              style: _vm.makeBGColor(8)
            },
            [
              _c("div", { staticClass: "card-header" }, [
                _c(
                  "a",
                  {
                    staticClass: "text-white",
                    attrs: { href: _vm.getUrl("disputed") }
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "div",
                          { staticClass: "row justify-content-between" },
                          [
                            _vm._m(10),
                            _vm._v(" "),
                            _c("div", { staticClass: "col text-right small" }, [
                              _vm._v(_vm._s(_vm.pods.disputed))
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 text-right mt-2 text-uppercase small"
                        },
                        [
                          _vm._v(
                            "\n                  Damaged/Short\n                "
                          )
                        ]
                      )
                    ])
                  ]
                )
              ])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c(
            "b-card",
            [
              _c(
                "b-tabs",
                {
                  attrs: { card: "", pills: "", align: "center" },
                  on: { input: _vm.tabChanged },
                  model: {
                    value: _vm.activeTab,
                    callback: function($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab"
                  }
                },
                [
                  _c("b-tab", { attrs: { title: "Overall" } }, [
                    _c("div", { staticClass: "row mt-1" }, [
                      _c("div", { staticClass: "col-6" }, [
                        _c(
                          "table",
                          {
                            staticClass:
                              "table table-borderless table-hover table-sm"
                          },
                          [
                            _c("thead", { staticClass: "thead-light" }, [
                              _c(
                                "tr",
                                [
                                  _c("th", [_vm._v("Category")]),
                                  _vm._v(" "),
                                  _vm._l(_vm.trends, function(m) {
                                    return _c("th", { key: m.month }, [
                                      _vm._v(_vm._s(m.month))
                                    ])
                                  })
                                ],
                                2
                              )
                            ]),
                            _vm._v(" "),
                            _c("tbody", [
                              !_vm.isTransporter
                                ? _c(
                                    "tr",
                                    [
                                      _c("td", [
                                        _vm._v("Total Invoices Generated")
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(_vm.trends, function(t) {
                                        return _c("td", { key: t.month }, [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: _vm.makeTrendLink(
                                                  t.month,
                                                  t.from,
                                                  t.to,
                                                  "created"
                                                )
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                          " +
                                                  _vm._s(
                                                    t.dashboardEntry.created
                                                  ) +
                                                  "\n                        "
                                              )
                                            ]
                                          )
                                        ])
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.isTransporter
                                ? _c(
                                    "tr",
                                    [
                                      _c("td", [
                                        _vm._v("Service Invoice (NPD)")
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(_vm.trends, function(t) {
                                        return _c("td", { key: t.month }, [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: _vm.makeTrendLink(
                                                  t.month,
                                                  t.from,
                                                  t.to,
                                                  "services"
                                                )
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                          " +
                                                  _vm._s(
                                                    t.dashboardEntry.noshipping
                                                  ) +
                                                  "\n                        "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "text-black-50" },
                                            [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(
                                                    _vm._f("toPct")(
                                                      t.dashboardEntry
                                                        .noshipping_pct
                                                    )
                                                  ) +
                                                  "%)"
                                              )
                                            ]
                                          )
                                        ])
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.isTransporter
                                ? _c(
                                    "tr",
                                    [
                                      _c("td", [_vm._v("Invoices Cancelled")]),
                                      _vm._v(" "),
                                      _vm._l(_vm.trends, function(t) {
                                        return _c("td", { key: t.month }, [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: _vm.makeTrendLink(
                                                  t.month,
                                                  t.from,
                                                  t.to,
                                                  "cancelled"
                                                )
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                          " +
                                                  _vm._s(
                                                    t.dashboardEntry.cancelled
                                                  ) +
                                                  "\n                        "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "text-black-50" },
                                            [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(
                                                    _vm._f("toPct")(
                                                      t.dashboardEntry
                                                        .cancelled_pct
                                                    )
                                                  ) +
                                                  "%)"
                                              )
                                            ]
                                          )
                                        ])
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "tr",
                                [
                                  _c("td", [_vm._v("Shipped Invoices")]),
                                  _vm._v(" "),
                                  _vm._l(_vm.trends, function(t) {
                                    return _c("td", { key: t.month }, [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.makeTrendLink(
                                              t.month,
                                              t.from,
                                              t.to,
                                              "shipped"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                          " +
                                              _vm._s(t.dashboardEntry.shipped) +
                                              "\n                        "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "text-black-50" },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm._f("toPct")(
                                                  t.dashboardEntry.shipped_pct
                                                )
                                              ) +
                                              "%)"
                                          )
                                        ]
                                      )
                                    ])
                                  })
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "tr",
                                [
                                  _c("td", [
                                    _vm._v("Shipments Delivered to Customer")
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.trends, function(t) {
                                    return _c("td", { key: t.month }, [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.makeTrendLink(
                                              t.month,
                                              t.from,
                                              t.to,
                                              "delivered"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                          " +
                                              _vm._s(
                                                t.dashboardEntry.delivered
                                              ) +
                                              "\n                        "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "text-black-50" },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm._f("toPct")(
                                                  t.dashboardEntry.delivered_pct
                                                )
                                              ) +
                                              "%)"
                                          )
                                        ]
                                      )
                                    ])
                                  })
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "tr",
                                [
                                  _c("td", [_vm._v("POD Uploaded")]),
                                  _vm._v(" "),
                                  _vm._l(_vm.trends, function(t) {
                                    return _c("td", { key: t.month }, [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.makeTrendLink(
                                              t.month,
                                              t.from,
                                              t.to,
                                              "uploaded"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                          " +
                                              _vm._s(
                                                t.dashboardEntry.uploaded
                                              ) +
                                              "\n                        "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "text-black-50" },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm._f("toPct")(
                                                  t.dashboardEntry.uploaded_pct
                                                )
                                              ) +
                                              "%)"
                                          )
                                        ]
                                      )
                                    ])
                                  })
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "tr",
                                [
                                  _c("td", [_vm._v("POD Upload Pending")]),
                                  _vm._v(" "),
                                  _vm._l(_vm.trends, function(t) {
                                    return _c("td", { key: t.month }, [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.makeTrendLink(
                                              t.month,
                                              t.from,
                                              t.to,
                                              "pending"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                          " +
                                              _vm._s(t.dashboardEntry.pending) +
                                              "\n                        "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "text-danger" },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm._f("toPct")(
                                                  t.dashboardEntry.pending_pct
                                                )
                                              ) +
                                              "%)"
                                          )
                                        ]
                                      )
                                    ])
                                  })
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "tr",
                                [
                                  _c("td", [
                                    _vm._v("In-Transit OR Update Pending")
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.trends, function(t) {
                                    return _c("td", { key: t.month }, [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.makeTrendLink(
                                              t.month,
                                              t.from,
                                              t.to,
                                              "undelivered"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                          " +
                                              _vm._s(
                                                t.dashboardEntry.undelivered
                                              ) +
                                              "\n                        "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "text-danger" },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm._f("toPct")(
                                                  t.dashboardEntry
                                                    .undelivered_pct
                                                )
                                              ) +
                                              "%)"
                                          )
                                        ]
                                      )
                                    ])
                                  })
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "tr",
                                [
                                  _c("td", [
                                    _vm._v("Shipments Returned To Warehouse")
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.trends, function(t) {
                                    return _c("td", { key: t.month }, [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.makeTrendLink(
                                              t.month,
                                              t.from,
                                              t.to,
                                              "returned"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                          " +
                                              _vm._s(
                                                t.dashboardEntry.returned
                                              ) +
                                              "\n                        "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "text-black-50" },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm._f("toPct")(
                                                  t.dashboardEntry.returned_pct
                                                )
                                              ) +
                                              "%)"
                                          )
                                        ]
                                      )
                                    ])
                                  })
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "tr",
                                { staticClass: "d-none" },
                                [
                                  _c("td", [
                                    _vm._v(
                                      "Shipment Delivered with Damage/Short Qty"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.trends, function(t) {
                                    return _c("td", { key: t.month }, [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.makeTrendLink(
                                              t.month,
                                              t.from,
                                              t.to,
                                              "disputed"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                          " +
                                              _vm._s(
                                                t.dashboardEntry.disputed
                                              ) +
                                              "\n                        "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "text-danger" },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm._f("toPct")(
                                                  t.dashboardEntry.disputed_pct
                                                )
                                              ) +
                                              "%)"
                                          )
                                        ]
                                      )
                                    ])
                                  })
                                ],
                                2
                              )
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c("column-chart", {
                            attrs: {
                              data: _vm.trendsChart,
                              colors: _vm.chartColors,
                              legend: false,
                              library: _vm.stackedBarOptions
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "table",
                            { staticClass: "table table-borderless table-sm" },
                            [
                              _c("thead", { staticClass: "thead-light" }, [
                                _c(
                                  "tr",
                                  [
                                    _c("th", [_vm._v("Category")]),
                                    _vm._v(" "),
                                    _vm._l(_vm.trends, function(m) {
                                      return _c("th", { key: m.month }, [
                                        _vm._v(_vm._s(m.month))
                                      ])
                                    })
                                  ],
                                  2
                                )
                              ]),
                              _vm._v(" "),
                              _c("tbody", [
                                _c(
                                  "tr",
                                  [
                                    _c("td", [
                                      _c(
                                        "span",
                                        { style: _vm.makeBGColor(0) },
                                        [_vm._v("  ")]
                                      ),
                                      _vm._v(
                                        "\n                      POD Uploaded"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(_vm.trends, function(t) {
                                      return _c("td", { key: t.month }, [
                                        _vm._v(
                                          _vm._s(t.dashboardEntry.uploaded) +
                                            " "
                                        )
                                      ])
                                    })
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "tr",
                                  [
                                    _c("td", [
                                      _c(
                                        "span",
                                        { style: _vm.makeBGColor(1) },
                                        [_vm._v("  ")]
                                      ),
                                      _vm._v(
                                        "\n                      In-Transit"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(_vm.trends, function(t) {
                                      return _c("td", { key: t.month }, [
                                        _vm._v(
                                          _vm._s(t.dashboardEntry.undelivered) +
                                            " "
                                        )
                                      ])
                                    })
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "tr",
                                  [
                                    _c("td", [
                                      _c(
                                        "span",
                                        { style: _vm.makeBGColor(4) },
                                        [_vm._v("  ")]
                                      ),
                                      _vm._v(
                                        "\n                      POD Pending"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(_vm.trends, function(t) {
                                      return _c("td", { key: t.month }, [
                                        _vm._v(
                                          _vm._s(t.dashboardEntry.pending) + " "
                                        )
                                      ])
                                    })
                                  ],
                                  2
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("b-tab", { attrs: { title: "Warehouse" } }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "table",
                          {
                            staticClass:
                              "table table-borderless table-hover tbl-tr table-sm"
                          },
                          [
                            _c("thead", { staticClass: "thead-dark" }, [
                              _c("tr", [
                                _c("th", [_vm._v("Name")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("Code")]),
                                _vm._v(" "),
                                _c("th", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "pb-0",
                                      on: {
                                        click: function($event) {
                                          return _vm.sortWH("created")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      Created "
                                      ),
                                      _vm.sortByWH === "created" &&
                                      _vm.sort === "asc"
                                        ? _c("i", {
                                            staticClass: "fa fa-angle-up"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.sortByWH === "created" &&
                                      _vm.sort === "desc"
                                        ? _c("i", {
                                            staticClass: "fa fa-angle-down"
                                          })
                                        : _vm._e()
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _vm._v(
                                    "\n                      Service Invoice (NPD)\n                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "pb-0",
                                      on: {
                                        click: function($event) {
                                          return _vm.sortWH("cancelled")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      Cancelled "
                                      ),
                                      _vm.sortByWH === "cancelled" &&
                                      _vm.sort === "asc"
                                        ? _c("i", {
                                            staticClass: "fa fa-angle-up"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.sortByWH === "cancelled" &&
                                      _vm.sort === "desc"
                                        ? _c("i", {
                                            staticClass: "fa fa-angle-down"
                                          })
                                        : _vm._e()
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "pb-0",
                                      on: {
                                        click: function($event) {
                                          return _vm.sortWH("shipped")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      Shipped "
                                      ),
                                      _vm.sortByWH === "shipped" &&
                                      _vm.sort === "asc"
                                        ? _c("i", {
                                            staticClass: "fa fa-angle-up"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.sortByWH === "shipped" &&
                                      _vm.sort === "desc"
                                        ? _c("i", {
                                            staticClass: "fa fa-angle-down"
                                          })
                                        : _vm._e()
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "pb-0",
                                      on: {
                                        click: function($event) {
                                          return _vm.sortWH("delivered")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      Delivered "
                                      ),
                                      _vm.sortByWH === "delivered" &&
                                      _vm.sort === "asc"
                                        ? _c("i", {
                                            staticClass: "fa fa-angle-up"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.sortByWH === "delivered" &&
                                      _vm.sort === "desc"
                                        ? _c("i", {
                                            staticClass: "fa fa-angle-down"
                                          })
                                        : _vm._e()
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "pb-0",
                                      on: {
                                        click: function($event) {
                                          return _vm.sortWH("delivered_pct")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      Delivered %"
                                      ),
                                      _vm.sortByWH === "delivered_pct" &&
                                      _vm.sort === "asc"
                                        ? _c("i", {
                                            staticClass: "fa fa-angle-up"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.sortByWH === "delivered_pct" &&
                                      _vm.sort === "desc"
                                        ? _c("i", {
                                            staticClass: "fa fa-angle-down"
                                          })
                                        : _vm._e()
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "pb-0",
                                      on: {
                                        click: function($event) {
                                          return _vm.sortWH("undelivered")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      In-Transit "
                                      ),
                                      _vm.sortByWH === "undelivered" &&
                                      _vm.sort === "asc"
                                        ? _c("i", {
                                            staticClass: "fa fa-angle-up"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.sortByWH === "undelivered" &&
                                      _vm.sort === "desc"
                                        ? _c("i", {
                                            staticClass: "fa fa-angle-down"
                                          })
                                        : _vm._e()
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("th", [_vm._v("In-Transit %")]),
                                _vm._v(" "),
                                _c("th", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "pb-0",
                                      on: {
                                        click: function($event) {
                                          return _vm.sortWH("returned")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      Returned "
                                      ),
                                      _vm.sortByWH === "returned" &&
                                      _vm.sort === "asc"
                                        ? _c("i", {
                                            staticClass: "fa fa-angle-up"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.sortByWH === "returned" &&
                                      _vm.sort === "desc"
                                        ? _c("i", {
                                            staticClass: "fa fa-angle-down"
                                          })
                                        : _vm._e()
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("th", [_vm._v("Returned %")]),
                                _vm._v(" "),
                                _c("th", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "pb-0",
                                      on: {
                                        click: function($event) {
                                          return _vm.sortWH("uploaded")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      Uploaded "
                                      ),
                                      _vm.sortByWH === "uploaded" &&
                                      _vm.sort === "asc"
                                        ? _c("i", {
                                            staticClass: "fa fa-angle-up"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.sortByWH === "uploaded" &&
                                      _vm.sort === "desc"
                                        ? _c("i", {
                                            staticClass: "fa fa-angle-down"
                                          })
                                        : _vm._e()
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "pb-0",
                                      on: {
                                        click: function($event) {
                                          return _vm.sortWH("pending")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      Pending "
                                      ),
                                      _vm.sortByWH === "pending" &&
                                      _vm.sort === "asc"
                                        ? _c("i", {
                                            staticClass: "fa fa-angle-up"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.sortByWH === "pending" &&
                                      _vm.sort === "desc"
                                        ? _c("i", {
                                            staticClass: "fa fa-angle-down"
                                          })
                                        : _vm._e()
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("th", [_vm._v("Pending %")]),
                                _vm._v(" "),
                                _c("th", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "pb-0",
                                      on: {
                                        click: function($event) {
                                          return _vm.sortWH("disputed")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      Bad POD "
                                      ),
                                      _vm.sortByWH === "disputed" &&
                                      _vm.sort === "asc"
                                        ? _c("i", {
                                            staticClass: "fa fa-angle-up"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.sortByWH === "disputed" &&
                                      _vm.sort === "desc"
                                        ? _c("i", {
                                            staticClass: "fa fa-angle-down"
                                          })
                                        : _vm._e()
                                    ]
                                  )
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              _vm._l(_vm.locationChartTableSorted, function(t) {
                                return _c("tr", { key: t.code }, [
                                  _c("td", [
                                    _vm.locationCodeMap[t.code0]
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.locationCodeMap[t.code0].name
                                            )
                                          )
                                        ])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(t.code))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.getLink(
                                            "wh",
                                            t.code0,
                                            "created"
                                          )
                                        }
                                      },
                                      [_vm._v(_vm._s(t.created))]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.getLink(
                                            "wh",
                                            t.code0,
                                            "services"
                                          )
                                        }
                                      },
                                      [_vm._v(_vm._s(t.noshipping))]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.getLink(
                                            "wh",
                                            t.code0,
                                            "cancelled"
                                          )
                                        }
                                      },
                                      [_vm._v(_vm._s(t.cancelled))]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.getLink(
                                            "wh",
                                            t.code0,
                                            "shipped"
                                          )
                                        }
                                      },
                                      [_vm._v(_vm._s(t.shipped))]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.getLink(
                                            "wh",
                                            t.code0,
                                            "delivered"
                                          )
                                        }
                                      },
                                      [_vm._v(_vm._s(t.delivered))]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "span",
                                      { staticClass: "text-success" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("toPct")(t.delivered_pct)
                                          ) + " %"
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.getLink(
                                            "wh",
                                            t.code0,
                                            "undelivered"
                                          )
                                        }
                                      },
                                      [_vm._v(_vm._s(t.undelivered))]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("span", { staticClass: "text-danger" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("toPct")(t.undelivered_pct)
                                        ) + " %"
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.getLink(
                                            "wh",
                                            t.code0,
                                            "returned"
                                          )
                                        }
                                      },
                                      [_vm._v(_vm._s(t.returned))]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("span", { staticClass: "text-danger" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("toPct")(t.returned_pct)
                                        ) + " %"
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.getLink(
                                            "wh",
                                            t.code0,
                                            "uploaded"
                                          )
                                        }
                                      },
                                      [_vm._v(_vm._s(t.uploaded))]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.getLink(
                                            "wh",
                                            t.code0,
                                            "pending"
                                          )
                                        }
                                      },
                                      [_vm._v(_vm._s(t.pending))]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("span", { staticClass: "text-danger" }, [
                                      _vm._v(
                                        _vm._s(_vm._f("toPct")(t.pending_pct)) +
                                          " %"
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.getLink(
                                            "wh",
                                            t.code0,
                                            "disputed"
                                          )
                                        }
                                      },
                                      [_vm._v(_vm._s(t.disputed))]
                                    )
                                  ])
                                ])
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c("tfoot", { staticClass: "bg-dark text-white" }, [
                              _c("tr", [
                                _c("td", { attrs: { colspan: "2" } }, [
                                  _vm._v("Total")
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(_vm.locationChartTotal.created))
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.locationChartTotal.noshipping)
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.locationChartTotal.cancelled)
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(_vm.locationChartTotal.shipped))
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.locationChartTotal.delivered)
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("toPct")(
                                        _vm.locationChartTotal.delivered_pct
                                      )
                                    ) + " %"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.locationChartTotal.undelivered)
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("toPct")(
                                        _vm.locationChartTotal.undelivered_pct
                                      )
                                    ) + " %"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.locationChartTotal.returned)
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("toPct")(
                                        _vm.locationChartTotal.returned_pct
                                      )
                                    ) + " %"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.locationChartTotal.uploaded)
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(_vm.locationChartTotal.pending))
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("toPct")(
                                        _vm.locationChartTotal.pending_pct
                                      )
                                    ) + " %"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.locationChartTotal.disputed)
                                  )
                                ])
                              ])
                            ])
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.isAdmin || _vm.isUser
                    ? _c("b-tab", { attrs: { title: "Transporter" } }, [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-11" }, [_vm._v(" ")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-1" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-info btn-sm",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.downloadExcel()
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "fa fa-download" }),
                                _vm._v(" Excel\n                ")
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 mt-3" }, [
                            _c(
                              "table",
                              {
                                staticClass:
                                  "table table-borderless table-hover tbl-tr table-sm"
                              },
                              [
                                _c("thead", { staticClass: "thead-dark" }, [
                                  _c("tr", [
                                    _c("th", [_vm._v("Name")]),
                                    _vm._v(" "),
                                    _vm.isAdmin
                                      ? _c("th", [_vm._v("Type")])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("th", [_vm._v("Code")]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "pb-0",
                                          on: {
                                            click: function($event) {
                                              return _vm.sortTR("created")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                        Assigned "
                                          ),
                                          _vm.sortBy === "created" &&
                                          _vm.sort === "asc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-up"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.sortBy === "created" &&
                                          _vm.sort === "desc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-down"
                                              })
                                            : _vm._e()
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "pb-0",
                                          on: {
                                            click: function($event) {
                                              return _vm.sortTR("delivered")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                        Delivered "
                                          ),
                                          _vm.sortBy === "delivered" &&
                                          _vm.sort === "asc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-up"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.sortBy === "delivered" &&
                                          _vm.sort === "desc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-down"
                                              })
                                            : _vm._e()
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "pb-0",
                                          on: {
                                            click: function($event) {
                                              return _vm.sortTR("delivered_pct")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                        Delivered % "
                                          ),
                                          _vm.sortBy === "delivered_pct" &&
                                          _vm.sort === "asc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-up"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.sortBy === "delivered_pct" &&
                                          _vm.sort === "desc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-down"
                                              })
                                            : _vm._e()
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "pb-0",
                                          on: {
                                            click: function($event) {
                                              return _vm.sortTR("undelivered")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                        In-Transit "
                                          ),
                                          _vm.sortBy === "undelivered" &&
                                          _vm.sort === "asc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-up"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.sortBy === "undelivered" &&
                                          _vm.sort === "desc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-down"
                                              })
                                            : _vm._e()
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "pb-0",
                                          on: {
                                            click: function($event) {
                                              return _vm.sortTR(
                                                "undelivered_pct"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                        In-Transit % "
                                          ),
                                          _vm.sortBy === "undelivered_pct" &&
                                          _vm.sort === "asc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-up"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.sortBy === "undelivered_pct" &&
                                          _vm.sort === "desc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-down"
                                              })
                                            : _vm._e()
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "pb-0",
                                          on: {
                                            click: function($event) {
                                              return _vm.sortTR("returned")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                        Returned "
                                          ),
                                          _vm.sortBy === "returned" &&
                                          _vm.sort === "asc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-up"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.sortBy === "returned" &&
                                          _vm.sort === "desc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-down"
                                              })
                                            : _vm._e()
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [_vm._v("Returned %")]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "pb-0",
                                          on: {
                                            click: function($event) {
                                              return _vm.sortTR("uploaded")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                        Uploaded "
                                          ),
                                          _vm.sortBy === "uploaded" &&
                                          _vm.sort === "asc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-up"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.sortBy === "uploaded" &&
                                          _vm.sort === "desc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-down"
                                              })
                                            : _vm._e()
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "pb-0",
                                          on: {
                                            click: function($event) {
                                              return _vm.sortTR("pending")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                        Pending "
                                          ),
                                          _vm.sortBy === "pending" &&
                                          _vm.sort === "asc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-up"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.sortBy === "pending" &&
                                          _vm.sort === "desc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-down"
                                              })
                                            : _vm._e()
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "pb-0",
                                          on: {
                                            click: function($event) {
                                              return _vm.sortTR("pending_pct")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                        Pending % "
                                          ),
                                          _vm.sortBy === "pending_pct" &&
                                          _vm.sort === "asc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-up"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.sortBy === "pending_pct" &&
                                          _vm.sort === "desc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-down"
                                              })
                                            : _vm._e()
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "pb-0",
                                          on: {
                                            click: function($event) {
                                              return _vm.sortTR("disputed")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                        Bad POD "
                                          ),
                                          _vm.sortBy === "bad" &&
                                          _vm.sort === "asc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-up"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.sortBy === "bad" &&
                                          _vm.sort === "desc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-down"
                                              })
                                            : _vm._e()
                                        ]
                                      )
                                    ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  _vm._l(
                                    _vm.transporterChartTableSorted,
                                    function(t) {
                                      return _c("tr", { key: t.code }, [
                                        _c("td", [
                                          _vm.trCodeMap[t.code0]
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.trCodeMap[t.code0].name
                                                  )
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.trCodeMap[t.code0] || !t.code
                                            ? _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [_vm._v("LR NOT UPDATED")]
                                              )
                                            : _vm._e()
                                        ]),
                                        _vm._v(" "),
                                        _vm.isAdmin
                                          ? _c("td", [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(t.trType) +
                                                  "\n                    "
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("td", [_vm._v(_vm._s(t.code))]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: _vm.getLink(
                                                  "tr",
                                                  t.code0,
                                                  "created"
                                                )
                                              }
                                            },
                                            [_vm._v(_vm._s(t.created))]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: _vm.getLink(
                                                  "tr",
                                                  t.code0,
                                                  "delivered"
                                                )
                                              }
                                            },
                                            [_vm._v(_vm._s(t.delivered))]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c(
                                            "span",
                                            { staticClass: "text-success" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("toPct")(
                                                    t.delivered_pct
                                                  )
                                                ) + " %"
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: _vm.getLink(
                                                  "tr",
                                                  t.code0,
                                                  "undelivered"
                                                )
                                              }
                                            },
                                            [_vm._v(_vm._s(t.undelivered))]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("toPct")(
                                                    t.undelivered_pct
                                                  )
                                                ) + " %"
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: _vm.getLink(
                                                  "tr",
                                                  t.code0,
                                                  "returned"
                                                )
                                              }
                                            },
                                            [_vm._v(_vm._s(t.returned))]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("toPct")(
                                                    t.returned_pct
                                                  )
                                                ) + " %"
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: _vm.getLink(
                                                  "tr",
                                                  t.code0,
                                                  "uploaded"
                                                )
                                              }
                                            },
                                            [_vm._v(_vm._s(t.uploaded))]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: _vm.getLink(
                                                  "tr",
                                                  t.code0,
                                                  "pending"
                                                )
                                              }
                                            },
                                            [_vm._v(_vm._s(t.pending))]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("toPct")(t.pending_pct)
                                                ) + " %"
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: _vm.getLink(
                                                  "tr",
                                                  t.code0,
                                                  "disputed"
                                                )
                                              }
                                            },
                                            [_vm._v(_vm._s(t.disputed))]
                                          )
                                        ])
                                      ])
                                    }
                                  ),
                                  0
                                ),
                                _vm._v(" "),
                                _c(
                                  "tfoot",
                                  { staticClass: "bg-dark text-white" },
                                  [
                                    _c("tr", [
                                      !_vm.isAdmin
                                        ? _c(
                                            "td",
                                            { attrs: { colspan: "2" } },
                                            [_vm._v("Total")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isAdmin
                                        ? _c(
                                            "td",
                                            { attrs: { colspan: "3" } },
                                            [_vm._v("Total")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.transporterChartTotal.created
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.transporterChartTotal.delivered
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("toPct")(
                                              _vm.transporterChartTotal
                                                .delivered_pct
                                            )
                                          ) + " %"
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.transporterChartTotal
                                              .undelivered
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("toPct")(
                                              _vm.transporterChartTotal
                                                .undelivered_pct
                                            )
                                          ) + " %"
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.transporterChartTotal.returned
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("toPct")(
                                              _vm.transporterChartTotal
                                                .returned_pct
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.transporterChartTotal.uploaded
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.transporterChartTotal.pending
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("toPct")(
                                              _vm.transporterChartTotal
                                                .pending_pct
                                            )
                                          ) + " %"
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.transporterChartTotal.disputed
                                          )
                                        )
                                      ])
                                    ])
                                  ]
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isAdmin || _vm.isUser
                    ? _c("b-tab", { attrs: { title: "Group" } }, [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12 mt-3" }, [
                            _c(
                              "table",
                              {
                                staticClass:
                                  "table table-borderless table-hover tbl-tr table-sm"
                              },
                              [
                                _c("thead", { staticClass: "thead-dark" }, [
                                  _c("tr", [
                                    _c("th", [_vm._v("Group")]),
                                    _vm._v(" "),
                                    _c("th", [_vm._v("Division")]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "pb-0",
                                          on: {
                                            click: function($event) {
                                              return _vm.sortGP("created")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      Created "
                                          ),
                                          _vm.sortByGP === "created" &&
                                          _vm.sort === "asc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-up"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.sortByGP === "created" &&
                                          _vm.sort === "desc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-down"
                                              })
                                            : _vm._e()
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _vm._v(
                                        "\n                      Service Invoice (NPD)\n                    "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "pb-0",
                                          on: {
                                            click: function($event) {
                                              return _vm.sortGP("cancelled")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      Cancelled "
                                          ),
                                          _vm.sortByGP === "cancelled" &&
                                          _vm.sort === "asc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-up"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.sortByGP === "cancelled" &&
                                          _vm.sort === "desc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-down"
                                              })
                                            : _vm._e()
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "pb-0",
                                          on: {
                                            click: function($event) {
                                              return _vm.sortGP("shipped")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      Shipped "
                                          ),
                                          _vm.sortByGP === "shipped" &&
                                          _vm.sort === "asc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-up"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.sortByGP === "shipped" &&
                                          _vm.sort === "desc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-down"
                                              })
                                            : _vm._e()
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "pb-0",
                                          on: {
                                            click: function($event) {
                                              return _vm.sortGP("delivered")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      Delivered "
                                          ),
                                          _vm.sortByGP === "delivered" &&
                                          _vm.sort === "asc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-up"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.sortByGP === "delivered" &&
                                          _vm.sort === "desc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-down"
                                              })
                                            : _vm._e()
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "pb-0",
                                          on: {
                                            click: function($event) {
                                              return _vm.sortGP("delivered_pct")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      Delivered %"
                                          ),
                                          _vm.sortByGP === "delivered_pct" &&
                                          _vm.sort === "asc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-up"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.sortByGP === "delivered_pct" &&
                                          _vm.sort === "desc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-down"
                                              })
                                            : _vm._e()
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "pb-0",
                                          on: {
                                            click: function($event) {
                                              return _vm.sortGP("undelivered")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      In-Transit "
                                          ),
                                          _vm.sortByGP === "undelivered" &&
                                          _vm.sort === "asc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-up"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.sortByGP === "undelivered" &&
                                          _vm.sort === "desc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-down"
                                              })
                                            : _vm._e()
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [_vm._v("In-Transit %")]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "pb-0",
                                          on: {
                                            click: function($event) {
                                              return _vm.sortGP("returned")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      Returned "
                                          ),
                                          _vm.sortByGP === "returned" &&
                                          _vm.sort === "asc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-up"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.sortByGP === "returned" &&
                                          _vm.sort === "desc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-down"
                                              })
                                            : _vm._e()
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [_vm._v("Returned %")]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "pb-0",
                                          on: {
                                            click: function($event) {
                                              return _vm.sortGP("uploaded")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      Uploaded "
                                          ),
                                          _vm.sortByGP === "uploaded" &&
                                          _vm.sort === "asc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-up"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.sortByGP === "uploaded" &&
                                          _vm.sort === "desc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-down"
                                              })
                                            : _vm._e()
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "pb-0",
                                          on: {
                                            click: function($event) {
                                              return _vm.sortGP("pending")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      Pending "
                                          ),
                                          _vm.sortByGP === "pending" &&
                                          _vm.sort === "asc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-up"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.sortByGP === "pending" &&
                                          _vm.sort === "desc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-down"
                                              })
                                            : _vm._e()
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [_vm._v("Pending %")]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "pb-0",
                                          on: {
                                            click: function($event) {
                                              return _vm.sortGP("disputed")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      Bad POD "
                                          ),
                                          _vm.sortByGP === "disputed" &&
                                          _vm.sort === "asc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-up"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.sortByGP === "disputed" &&
                                          _vm.sort === "desc"
                                            ? _c("i", {
                                                staticClass: "fa fa-angle-down"
                                              })
                                            : _vm._e()
                                        ]
                                      )
                                    ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  _vm._l(_vm.groupChartTableSorted, function(
                                    t
                                  ) {
                                    return _c("tr", { key: t.code }, [
                                      _c("td", [_vm._v(_vm._s(t.group))]),
                                      _vm._v(" "),
                                      _c("td", [_vm._v(_vm._s(t.code))]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.getLink(
                                                "gp",
                                                t.code,
                                                "created"
                                              )
                                            }
                                          },
                                          [_vm._v(_vm._s(t.created))]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.getLink(
                                                "gp",
                                                t.code,
                                                "services"
                                              )
                                            }
                                          },
                                          [_vm._v(_vm._s(t.noshipping))]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.getLink(
                                                "gp",
                                                t.code,
                                                "cancelled"
                                              )
                                            }
                                          },
                                          [_vm._v(_vm._s(t.cancelled))]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.getLink(
                                                "gp",
                                                t.code,
                                                "shipped"
                                              )
                                            }
                                          },
                                          [_vm._v(_vm._s(t.shipped))]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.getLink(
                                                "gp",
                                                t.code,
                                                "delivered"
                                              )
                                            }
                                          },
                                          [_vm._v(_vm._s(t.delivered))]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "span",
                                          { staticClass: "text-success" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("toPct")(t.delivered_pct)
                                              ) + " %"
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.getLink(
                                                "gp",
                                                t.code,
                                                "undelivered"
                                              )
                                            }
                                          },
                                          [_vm._v(_vm._s(t.undelivered))]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("toPct")(
                                                  t.undelivered_pct
                                                )
                                              ) + " %"
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.getLink(
                                                "gp",
                                                t.code,
                                                "returned"
                                              )
                                            }
                                          },
                                          [_vm._v(_vm._s(t.returned))]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("toPct")(t.returned_pct)
                                              ) + " %"
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.getLink(
                                                "gp",
                                                t.code,
                                                "uploaded"
                                              )
                                            }
                                          },
                                          [_vm._v(_vm._s(t.uploaded))]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.getLink(
                                                "gp",
                                                t.code,
                                                "pending"
                                              )
                                            }
                                          },
                                          [_vm._v(_vm._s(t.pending))]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("toPct")(t.pending_pct)
                                              ) + " %"
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.getLink(
                                                "gp",
                                                t.code,
                                                "disputed"
                                              )
                                            }
                                          },
                                          [_vm._v(_vm._s(t.disputed))]
                                        )
                                      ])
                                    ])
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _c(
                                  "tfoot",
                                  { staticClass: "bg-dark text-white" },
                                  [
                                    _c("tr", [
                                      _c("td", { attrs: { colspan: "2" } }, [
                                        _vm._v("Total")
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.groupChartTotal.created)
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.groupChartTotal.noshipping)
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.groupChartTotal.cancelled)
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.groupChartTotal.shipped)
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.groupChartTotal.delivered)
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("toPct")(
                                              _vm.groupChartTotal.delivered_pct
                                            )
                                          ) + " %"
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.groupChartTotal.undelivered
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("toPct")(
                                              _vm.groupChartTotal
                                                .undelivered_pct
                                            )
                                          ) + " %"
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.groupChartTotal.returned)
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("toPct")(
                                              _vm.groupChartTotal.returned_pct
                                            )
                                          ) + " %"
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.groupChartTotal.uploaded)
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.groupChartTotal.pending)
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("toPct")(
                                              _vm.groupChartTotal.pending_pct
                                            )
                                          ) + " %"
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.groupChartTotal.disputed)
                                        )
                                      ])
                                    ])
                                  ]
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-1", staticStyle: { "margin-right": "auto" } },
      [_c("h3", { staticClass: "form-head" }, [_vm._v("Dashboard")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("i", { staticClass: "far fa-truck-loading fa-2x" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("i", { staticClass: "far fa-ban fa-2x" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("i", { staticClass: "far fa-clipboard-check fa-2x" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("i", { staticClass: "far fa-shipping-fast fa-2x" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("i", { staticClass: "far fa-box-check fa-2x" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("i", { staticClass: "far fa-undo fa-2x" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("i", { staticClass: "fa fa-upload fa-2x" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("i", { staticClass: "fa fa-exclamation-triangle fa-2x" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("i", { staticClass: "fa fa-clock fa-2x" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("i", { staticClass: "fa fa-times-hexagon fa-2x" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a12e41a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a12e41a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PODHomePage.vue
// module id = null
// module chunks = 